export enum OperationResult {
  Success,
  StoredOffline,
  Error,
  Timeout,
  No_connection
}

